import { IBar, INote, IScoreEditorThis } from "../../../../../common/types";
import { getBarTotalLength } from "./getBarTotalLength";
import { getRealLength } from "./getRealLength";


export const handleRhythmChange = function (this: IScoreEditorThis, rhytLength: INote["l"] | null, dotting?: boolean) {
  const { activeVoice } = this.state;
  const score = { ...this.state.score };
  const bars = score["bars" + (activeVoice || "")] as IBar[];
  const { bar, note, lyric } = this.state.selectedNote!;
  if (lyric) return;
  const currentNote = bars[bar].notes[note];
  if (dotting && currentNote.l === 16) return;
  if (currentNote.l === rhytLength && !dotting) return;
  if (dotting) rhytLength = currentNote.l;
  const oldLength = getRealLength(currentNote) * (currentNote.t ? 2 : 3);
  const newLength = (4 / rhytLength!) * (dotting && !currentNote.d ? 1.5 : 1) * (currentNote.t ? 2 : 3);

  let prevNotes = bars[bar].notes.slice(0, note);

  let barLength = 0;
  if (prevNotes.length !== 0) {
      barLength = prevNotes
          .map((note, index) => {
              let noteLength = getRealLength(note) * (note.t ? 2 : 3);
              return noteLength;
          })
          .reduce((total, next) => total + next);
  }
  barLength += newLength;
  let barTotalLength = getBarTotalLength(score.signatures, bar) * 3;
  if (barTotalLength < barLength) {
      return this.setState({ fullBar: true });
  }

  if (barTotalLength === barLength) {
      if (!bars[bar + 1]) {
          bars[bar + 1] = { notes: [] };
      }
  }

  let noteLengthToAdd;
  let wasDotted = currentNote.d;
  if (oldLength > newLength) {
      // kitöltés
      currentNote.l = rhytLength!;
      delete currentNote.d;
      noteLengthToAdd = oldLength - newLength;
  } else {
      // elvétel
      currentNote.l = rhytLength!;
      delete currentNote.d;
      let lengthToRemove = newLength - oldLength;
      let noteIndex = note + 1;
      let noteToRemove = bars[bar].notes[noteIndex];
      while (lengthToRemove > 0 && noteToRemove) {
          lengthToRemove -= getRealLength(noteToRemove) * (noteToRemove.t ? 2 : 3);
          bars[bar].notes.splice(noteIndex, 1);
          noteToRemove = bars[bar].notes[noteIndex];
      }
      if (lengthToRemove !== 0) {
          noteLengthToAdd = -lengthToRemove;
      } else {
          noteLengthToAdd = 0;
      }
  }
  const addNotes = (...notes: INote[]) => {
      bars[bar].notes.splice(
          note + 1,
          0,
          ...notes.map(note => ({
              ...(currentNote.p && { p: currentNote.p }),
              ...(currentNote.t && { t: currentNote.t }),
              ...note,
          }))
      );
  };
  if (bars[bar].notes[note + 1] || bars[bar + 1]) {
      switch (noteLengthToAdd / 3) {
          case 4: {
              addNotes({ l: 1 });
              break;
          }
          case 3.75: {
              addNotes({ l: 8, d: 1 }, { l: 2, d: 1 });
              break;
          }
          case 3.5: {
              addNotes({ l: 8 }, { l: 2, d: 1 });
              break;
          }
          case 3.25: {
              addNotes({ l: 2, d: 1 }, { l: 16 });
              break;
          }
          case 3: {
              addNotes({ l: 2, d: 1 });
              break;
          }
          case 2.75: {
              addNotes({ l: 2 }, { l: 8, d: 1 });
              break;
          }
          case 2.5: {
              addNotes({ l: 2 }, { l: 8 });
              break;
          }
          case 2.25: {
              addNotes({ l: 16 }, { l: 2 });
              break;
          }
          case 2: {
              addNotes({ l: 2 });
              break;
          }
          case 1.75: {
              addNotes({ l: 16 }, { l: 4, d: 1 });
              break;
          }
          case 1.5: {
              addNotes({ l: 4, d: 1 });
              break;
          }
          case 1.25: {
              addNotes({ l: 16 }, { l: 4 });
              break;
          }
          case 1: {
              addNotes({ l: 4 });
              break;
          }
          case 0.75: {
              addNotes({ l: 8, d: 1 });
              break;
          }
          case 0.5: {
              addNotes({ l: 8 });
              break;
          }
          case 0.25: {
              addNotes({ l: 16 });
              break;
          }
          default: {
              break;
          }
      }
  }
  if (!wasDotted && dotting) {
      currentNote.d = 1;
  }
  this.setState({ score, fullBar: false });
};